import { ColorRGBA, colorToHex, colorsEqual, hexToColor } from '../../../types/appearance';
import './ColorSwatchPicker.css';

interface ColorSwatchPickerProps {
  label: string;
  presets: { color: ColorRGBA; label: string }[];
  selectedColor: ColorRGBA;
  onChange: (color: ColorRGBA) => void;
}

export function ColorSwatchPicker({
  label,
  presets,
  selectedColor,
  onChange,
}: ColorSwatchPickerProps) {
  return (
    <div className="color-swatch-picker">
      <label className="picker-label">{label}</label>
      <div className="swatches">
        {presets.map((preset, index) => (
          <button
            key={index}
            type="button"
            className={`swatch ${colorsEqual(preset.color, selectedColor) ? 'selected' : ''}`}
            style={{ backgroundColor: colorToHex(preset.color) }}
            onClick={() => onChange(preset.color)}
            title={preset.label}
            aria-label={preset.label}
          />
        ))}
        <input
          type="color"
          className={`swatch swatch-custom ${
            presets.some((preset) => colorsEqual(preset.color, selectedColor)) ? '' : 'selected'
          }`}
          value={colorToHex(selectedColor)}
          onChange={(e) => onChange(hexToColor(e.target.value))}
          title="Custom color"
          aria-label={`Custom ${label.toLowerCase()} color`}
        />
      </div>
    </div>
  );
}

export default ColorSwatchPicker;
